module.exports = __webpack_public_path__ + "img/txt.68da6822.png";